import axios from '@axios'

const PREFIX = '/template-email'

export default {

  getTemplates(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  salvarTemplate(template) {
    return axios.post(`${PREFIX}/add`, template)
  },

  updateTemplate(id, template) {
    return axios.put(`${PREFIX}/${id}`, template)
  },

  deleteTemplate(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  getTemplateById(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  delete(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },
  validaTemplates(formData) {
    return axios.post(`${PREFIX}/valida-templates`, formData)
  },
  getPadrao(tipoEmail) {
    return axios.get(`${PREFIX}/restaurar-padrao/${tipoEmail}`)
  },
}
